export default __webpack_public_path__ + "static/media/TreatmentOutcomes.8c7a9527.svg";